/**
 * E4/G1c ·「这个好,入库」的判据(design §8「军师产出 → 用户"这个好,入库"」)。
 *
 * 提名走的是 §8「**不重传**,只多一个 source_type」:后端只记 (taskId, seq),让 ai 直接引用
 * gscq-media 桶里那件产物。重传一份意味着同一张图在两个桶各存一份、各自过期、各自被删 ——
 * 客服吐出来的那份和用户在海报页看到的那份迟早不是同一张。
 */

/** 只要 status 这一个字段 —— 海报的 PosterAssetDto 与视频的产物 DTO 形状不同,别把整个 DTO 拖进来。 */
type NominatableAsset = { status?: string | null };

/**
 * 这件产物能不能提名入库。
 *
 * **只有出图成功的能**:提名不重传字节,后端只记 (taskId, seq) 让 ai 引用 media 桶里那件产物。
 * 产物压根没生成的话,建出来的是一个**指向空气的知识对象** —— 而它会一路躺到审批台上等人批,
 * 审批人还看不出它是空的。fail-closed:状态拿不准就别建。
 *
 * 这不是唯一防线(后端 nominate 也会校验),这里是别把按钮亮着骗人。
 */
export function canNominateToKb(asset: NominatableAsset): boolean {
  return asset.status === "SUCCESS";
}
